<template>
    <nav class="page navigation">
        <ul class="pagination justify-content-center">
            <li :class="[`page-item`, { disabled: currentPage === 1 }]">
                <button class="page-link bg-success text-light" @click="handlePageChange(1)" :disabled="currentPage === 1">{{ '<<' }}</button>
            </li>

            <li :class="[`page-item`, { disabled: currentPage === 1 }]">
                <button class="page-link bg-success text-light" @click="handlePageChange(currentPage - 1)" :disabled="currentPage === 1">{{ '<' }}</button>
            </li>

            <li v-for="(page, idx_page) in getPageNumbers()" :key="idx_page" :class="[`page-item`, { active: currentPage === page }]">
                <button class="page-link" @click="handlePageChange(page)" :disabled="currentPage === page">{{ page }}</button>
            </li>

            <li :class="[`page-item`, { disabled: currentPage === totalPages }]">
                <button class="page-link bg-success text-light" @click="handlePageChange(currentPage + 1)" :disabled="currentPage === totalPages">{{ '>' }}</button>
            </li>

            <li :class="[`page-item`, { disabled: currentPage === totalPages }]">
                <button class="page-link bg-success text-light" @click="handlePageChange(totalPages)" :disabled="currentPage === totalPages">{{ '>>' }}</button>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    props: {
        totalItems: {
            type: Number,
            required: true
        },
        itemsPerPage: {
            type: Number,
            required: true
        },
        maxPageButtons: {
            type: Number,
            required: true
        },
        page: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            currentPage: this.page
        }
    },
    watch: {
        page(newVal) {
            this.currentPage = newVal
        }
    },
    computed: {
        totalPages() {
            return Math.ceil(this.totalItems / this.itemsPerPage)
        }
    },
    methods: {
        getPageNumbers() {
            let startPage, endPage;
            if (this.totalPages <= this.maxPageButtons) {
                startPage = 1;
                endPage = this.totalPages;
            } else {
                const maxPagesBeforeCurrentPage = Math.floor(this.maxPageButtons / 2);
                const maxPagesAfterCurrentPage = Math.ceil(this.maxPageButtons / 2) - 1;
                if (this.currentPage <= maxPagesBeforeCurrentPage) {
                    startPage = 1;
                    endPage = this.maxPageButtons;
                } else if (this.currentPage + maxPagesAfterCurrentPage >= this.totalPages) {
                    startPage = this.totalPages - this.maxPageButtons + 1;
                    endPage = this.totalPages;
                } else {
                    startPage = this.currentPage - maxPagesBeforeCurrentPage;
                    endPage = this.currentPage + maxPagesAfterCurrentPage;
                }
            }

            return Array.from({ length: endPage - startPage + 1 }, (_, idx) => startPage + idx)
        },
        handlePageChange(pageNumber) {
            this.currentPage = pageNumber
            this.$emit('update:page', pageNumber)
        }
    }
}
</script>
